<template lang="pug">
	article#news-article(:aria-busy="translation.title ? 'false' : 'true'")
		.post(v-if="translation.title")
			picture.cover(v-if="cover && !coverFailed", :class="{ loading: !coverLoaded }")
				//- Sem texto alternativo a capa é decorativa: o título já está logo abaixo
				img(
					:key="cover.filePath",
					:src="cover.filePath",
					:alt="cover.altText || ''",
					fetchpriority="high",
					@load="coverLoaded = true",
					@error="coverFailed = true"
				)

			header.heading
				h1.title {{ translation.title }}
				p.description(v-if="translation.description") {{ translation.description }}
				ul.meta
					li
						SvgIcon.icon(data="@svgs/news-category.svg", original, aria-hidden="true")
						router-link.highlight(:to="categoryRoute") {{ category }}
					li(v-if="translation.publishedAt")
						SvgIcon.icon(data="@svgs/news-date.svg", original, aria-hidden="true")
						time(:datetime="translation.publishedAt") {{ formatDate(translation.publishedAt) }}

			TiptapContent(v-if="doc", :doc="doc")
			Conteudo(v-else-if="blocks.length", :contents="blocks")

			footer.footer
				.category
					span.label Categoria
					router-link.tag(:to="categoryRoute") {{ category }}
				Compartilhamento

		//- Esqueleto enquanto a notícia carrega
		.post.skeleton(v-else, aria-hidden="true")
			.cover.loading
			.heading
				span.bar.title-bar
				span.bar.title-bar.short
				span.bar.text-bar
				span.bar.meta-bar
			.body
				span.bar.text-bar(v-for="line in 5", :key="line")
				span.bar.text-bar.short
</template>

<script>
import Compartilhamento from '@sections/Pagina/Compartilhamento/Compartilhamento.vue'
import Conteudo from '@sections/Pagina/Conteudo/Conteudo.vue'
import TiptapContent from '@components/Tiptap/TiptapContent.vue'
import news, { NEWS_LIST_PATH, UNCATEGORIZED_TAB } from '@/mixins/news'

export default {
	name: "section-news-article",
	mixins: [ news ],
	components: {
		Compartilhamento,
		Conteudo,
		TiptapContent,
	},
	props: {
		news: {
			type: Object,
			required: true,
		},
		translation: {
			type: Object,
			required: true,
		},
		blocks: {
			type: Array,
			default: () => [],
		},
		// Documento do editor novo (tem prioridade sobre `blocks`)
		doc: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			coverLoaded: false,
			// Imagem com erro: a capa sai da tela em vez de mostrar o ícone quebrado
			coverFailed: false,
		}
	},
	computed: {
		cover() {
			return this.translation.banner || null
		},
		category() {
			return this.news.category ? this.news.category.name : UNCATEGORIZED_TAB.label
		},
		// Listagem com a aba da categoria já selecionada (mesma query usada pelas abas)
		categoryRoute() {
			const category = this.news.category ? String(this.news.category.id) : UNCATEGORIZED_TAB.key
			return { path: `/${this.$store.state.locale}/${NEWS_LIST_PATH}`, query: { category } }
		},
	},
	watch: {
		// Outra notícia na mesma view: a nova capa começa a carregar do zero
		cover(to, from) {
			if (!to || !from || to.filePath !== from.filePath) {
				this.coverLoaded = false
				this.coverFailed = false
			}
		},
	},
}
</script>

<style lang="stylus" scoped src="./NewsArticle.styl"></style>
